import React, { useState } from "react";
import { FaArrowRight, FaCheck } from "react-icons/fa";

const ConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  subtitle,
  btn_cancel = "Batal",
  btn_text = "Ya, Lanjutkan",
  check_text = "Ya, Saya yakin akan melanjutkan",
  showChecked = false,
  isArrow = true
}) => {
  const [isChecked, setIsChecked] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!showChecked || isChecked) {
      setIsChecked(false); // Reset checkbox
      onConfirm();
    }
  };

  const handleCancel = () => {
    setIsChecked(false); // Reset checkbox
    onCancel();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className="login-container bg-white rounded-lg shadow-lg max-w-sm w-full">
      <div className="bg-[#558C87] text-xl text-center text-white font-normal py-2 rounded-t-lg">
        {title}
      </div>
        <div className="flex flex-col px-6 mt-4 py-2">
          <p className="text-sm mb-4 text-left">{subtitle}</p>
          
          {showChecked && (
            <div className="mb-4">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-700">
                  {check_text}
                </span>
              </label>
            </div>
          )}

            <div className="flex flex-row justify-center items-center gap-2">
              <button
                onClick={handleCancel}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 rounded-2xl"
              >
                {btn_cancel}
              </button>
              <button
                onClick={handleConfirm}
                disabled={showChecked && !isChecked}
                className={`px-4 py-2 rounded-2xl ${
                  (!showChecked || isChecked)
                    ? "backgroundColor text-white hover:bg-slate-600"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              >
                {btn_text}
                {isArrow && <FaArrowRight className="inline-block ml-2" />}
              </button>
            </div>
        </div>
        
      </div>
    </div>
  );
};

export default ConfirmationModal;
